// This was a thought trace.
// I will view socket.js and ExerciseCreateReducer.js.

import types from '../../constants';
import auth from '../../auth';
import helpers from '../../helpers';

export function changeForm(field, value) {
  return {
    type: types.EXERCISE_CREATE_CHANGE_FORM,
    payload: { field, value },
  };
}

export function selectScenario(id) {
  return { type: types.EXERCISE_CREATE_SELECT_SCENARIO, payload: id };
}

export function create(data) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_CREATE_LOADING_START });

    global.socket.emit('exercise_create', data);
  };
}

export function creationOk(id) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_CREATE_LOADING_END });
    dispatch({ type: types.EXERCISE_CREATE_CLEAR_ERROR });

    dispatch({ type: types.EXERCISE_CREATE_SUCCESS, payload: id });
    // history.push(`/exercises/${id}`);
  };
}

export function creationFail(message) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_CREATE_LOADING_END });
    dispatch({
      type: types.EXERCISE_CREATE_SET_ERROR,
      payload: message,
    });
  };
}

export function clearExercise() {
  return { type: types.EXERCISE_CREATE_CLEAR };
}

export function fetchScenarios() {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  const companyId = user.company._id;

  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_CREATE_LOADING_START });
    dispatch({ type: types.EXERCISE_CREATE_CLEAR_ERROR });
    fetch(`/api/scenarios/${companyId}`, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.EXERCISE_CREATE_SCENARIOS_LIST,
          payload: data.scenarios,
        });
        dispatch({ type: types.EXERCISE_CREATE_LOADING_END });
      })
      .catch((err) => {
        console.log('Error:', err); // eslint-disable-line
      });

    return true;
  };
}
